<template>
  <div class="footer">
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <router-link to="/terms-and-conditions">Общи условия</router-link> |
          <router-link to="/cookies"
            >Политика за използване на cookies</router-link
          >
          |
          <router-link to="/privacy-policy"
            >Политика за поверителност</router-link
          >
          |
          <router-link to="/payment-information">Методи на плащане</router-link>
          |
          <router-link to="/customer-service-policies">
            Политики за работа с клиенти
          </router-link>
          | <router-link to="/euro-projects">Европроекти</router-link> |
          <router-link to="/contacts">Контакти</router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="scss">
.footer {
  background: #208ffd;
  width: 100%;
  color: white;

  a {
    color: white;
  }
}
</style>
